import React from 'react';
import { Routes, Route, Navigate, NavLink } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import Tasks from './components/Tasks';
import RankingList from './components/RankingList';
import Account from './components/Account';
import LoginForm from './components/LoginForm';
import Podium from './components/PodiumAnimation';
import AdminPanel from './components/AdminPanel';
import EndGameScreen from './components/EndGameScreen';
import TutorialOverlay from './components/TutorialOverlay';
import LandingPage from './components/LandingPage';
import BackgroundAnimation from './components/BackgroundAnimation';
import { API_BASE_URL } from './config';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import logo from './assets/logo.jpg'; // Make sure to add the logo to this path

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [ranking, setRanking] = useState([]);
  const [isGameEnded, setIsGameEnded] = useState(false);
  const [showTutorial, setShowTutorial] = useState(
    localStorage.getItem('hasSeenTutorial') !== 'true'
  );

  useEffect(() => {
    const checkAuth = async () => {
      const username = localStorage.getItem('username');
      if (!username) {
        setIsLoggedIn(false);
        return;
      }

      try {
        const response = await axios.get(`${API_BASE_URL}/check-user/${username}`);
        if (!response.data.exists) {
          localStorage.removeItem('username');
          setIsLoggedIn(false);
        } else {
          setIsLoggedIn(true);
          if (localStorage.getItem('hasSeenTutorial') !== 'true') {
            setShowTutorial(true);
          }
        }
      } catch (error) {
        console.error('Error checking user:', error);
        localStorage.removeItem('username');
        setIsLoggedIn(false);
      }
    };

    checkAuth();
  }, []);

  useEffect(() => {
    const fetchRanking = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/ranking`);
        setRanking(response.data);
      } catch (error) {
        console.error('Error fetching ranking:', error);
      }
    };

    fetchRanking();
    const interval = setInterval(fetchRanking, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const checkGameStatus = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/game-status`);
        setIsGameEnded(response.data.isGameEnded);
      } catch (error) {
        console.error('Error checking game status:', error);
      }
    };

    checkGameStatus();
    const interval = setInterval(checkGameStatus, 10000);
    return () => clearInterval(interval);
  }, []);

  const username = localStorage.getItem('username');
  const currentUserStats = ranking.find(user => user.username === username);

  // Dodaj funkcję do przekierowania i odświeżenia
  const redirectToTasksAndReload = () => {
    setIsLoggedIn(true);
  };

  if (!isLoggedIn) {
    return (
      <>
        <BackgroundAnimation />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginForm onLogin={redirectToTasksAndReload} />} />
          <Route path="/admin" element={
            <div className="fixed inset-0 z-[100]">
              <AdminPanel />
            </div>
          } />  
           
          <Route path="*" element={<Navigate to="/" replace />} />
        
        </Routes>
      </>
    );
  }

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        theme="dark"
      />
      
      <TutorialOverlay
        isOpen={showTutorial}
        onClose={() => {
          setShowTutorial(false);
          localStorage.setItem('hasSeenTutorial', 'true');
        }}
      />

      {isGameEnded && <EndGameScreen />}
      
      <div className="min-h-screen bg-gray-900">
        <header className="bg-[#1E3A8A] text-white p-6">
          <div className="container mx-auto flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img src={logo} alt="Wilcza Watacha" className="h-16 w-auto" />
              <h1 className="text-2xl font-bold text-white">
                Witaj, {localStorage.getItem('username')}
              </h1>
            </div>
          </div>
        </header>
        <nav className="bg-gray-800 border-b border-gray-700">
          <div className="flex justify-center space-x-8 py-2">
            <NavLink to="/tasks" className={({ isActive }) =>
              `px-4 py-2 ${isActive ? 'text-[#3B82F6] border-b-2 border-[#3B82F6]' : 'text-gray-300 hover:text-white'}`
            }>
              ZADANIA
            </NavLink>
            <NavLink to="/ranking" className={({ isActive }) =>
              `px-4 py-2 ${isActive ? 'text-[#3B82F6] border-b-2 border-[#3B82F6]' : 'text-gray-300 hover:text-white'}`
            }>
              RANKING
            </NavLink>
            <NavLink to="/podium" className={({ isActive }) =>
              `px-4 py-2 ${isActive ? 'text-[#3B82F6] border-b-2 border-[#3B82F6]' : 'text-gray-300 hover:text-white'}`
            } style={{ display: 'none' }}>
              PODIUM
            </NavLink>
            <NavLink to="/account" className={({ isActive }) =>
              `px-4 py-2 ${isActive ? 'text-[#3B82F6] border-b-2 border-[#3B82F6]' : 'text-gray-300 hover:text-white'}`
            }>
              MOJE KONTO
            </NavLink>
          </div>
        </nav>
        <main className="container mx-auto px-4 py-6 text-white">
          <Routes>
            <Route path="/" element={<Tasks username={username} />} />
            <Route path="/tasks" element={<Tasks username={username} />} />
            <Route path="/ranking" element={<RankingList ranking={ranking} />} />
            <Route path="/account" element={<Account />} />
            <Route path="/podium" element={<Podium winners={ranking.slice(0, 3)} />} />
            <Route path="/admin" element={
              <div className="fixed inset-0 z-[100]">
                <AdminPanel />
              </div>
            } />
            <Route path="/event-info" element={
              <>
                <BackgroundAnimation />
                <LandingPage />
              </>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </>
  );
}

export default App;
